import styled from "styled-components";

const Button = styled.button`
    display:flex;
    align-items:center;
    justify-content:center;
    width:100%;
    height: 65px;
    background-color: #1877F2;
    border-radius: 6px;
    font-family: 'Oswald';
    font-style: normal;
    font-weight: 700;
    font-size: 27px;
    line-height: 40px;
    color: #FFFFFF;
    cursor: pointer;
    border:none;
`;

export default Button;